import { render, staticRenderFns } from "./QuoteSlice.vue?vue&type=template&id=6fa1d418&scoped=true&"
import script from "./QuoteSlice.vue?vue&type=script&lang=js&"
export * from "./QuoteSlice.vue?vue&type=script&lang=js&"
import style0 from "./QuoteSlice.vue?vue&type=style&index=0&id=6fa1d418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa1d418",
  null
  
)

export default component.exports